import { render, staticRenderFns } from "./OpenDataContentFooter.vue?vue&type=template&id=8a3ccfae&scoped=true"
import script from "./OpenDataContentFooter.vue?vue&type=script&lang=js"
export * from "./OpenDataContentFooter.vue?vue&type=script&lang=js"
import style0 from "./OpenDataContentFooter.vue?vue&type=style&index=0&id=8a3ccfae&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3ccfae",
  null
  
)

export default component.exports